import React, { useState, useRef, useEffect } from 'react';
import '../styles/RadiusSelector.css';

function RadiusSelector({ selectedRadius, setSelectedRadius, compact = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const [customValue, setCustomValue] = useState('');
  const [showCustomInput, setShowCustomInput] = useState(false);
  const dropdownRef = useRef(null);

  const radiusOptions = [1, 5, 10, 25, 50];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleRadiusSelect = (radius) => {
    if (radius === 'custom') {
      setShowCustomInput(true);
    } else {
      setSelectedRadius(radius);
      setShowCustomInput(false);
      if (!compact) {
        setIsOpen(false);
      }
    }
  };

  const MAX_RADIUS = 50;

  const handleCustomSubmit = (e) => {
    e.preventDefault();
    const value = parseFloat(customValue);
    if (value && value > 0) {
      const roundedValue = Math.min(Math.round(value), MAX_RADIUS);
      setSelectedRadius(roundedValue);
      setCustomValue('');
      setShowCustomInput(false);
    }
  };

  return (
    <div className={`radius-selector ${compact ? 'compact' : ''}`} ref={dropdownRef}>
      <button
        className="radius-button"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <span>{selectedRadius} miles</span>
        <span className={`arrow ${isOpen ? 'up' : 'down'}`}>▼</span>
      </button>

      {isOpen && (
        <div className="radius-dropdown">
          {radiusOptions.map((radius) => (
            <div
              key={radius}
              className={`radius-option ${selectedRadius === radius ? 'selected' : ''}`}
              onClick={() => handleRadiusSelect(radius)}
            >
              {selectedRadius === radius && <span className="checkmark">✓</span>}
              <span>{radius} miles</span>
            </div>
          ))}
          <div
            className={`radius-option ${!radiusOptions.includes(selectedRadius) ? 'selected' : ''}`}
            onClick={() => handleRadiusSelect('custom')}
          >
            {!radiusOptions.includes(selectedRadius) && <span className="checkmark">✓</span>}
            <span>Custom</span>
          </div>

          {showCustomInput && (
            <form className="custom-input-container" onSubmit={handleCustomSubmit}>
              <input
                type="number"
                className="custom-input"
                placeholder="Enter miles (max 50)..."
                value={customValue}
                onChange={(e) => setCustomValue(e.target.value)}
                min="1"
                max="50"
                step="1"
                autoFocus
              />
            </form>
          )}
          <div className="radius-max-note">Max radius: 50 miles</div>
        </div>
      )}
    </div>
  );
}

export default RadiusSelector;
